import { render } from "./indicator.vue?vue&type=template&id=0c3dd10a&scoped=true"
import script from "./indicator.vue?vue&type=script&lang=js"
export * from "./indicator.vue?vue&type=script&lang=js"

import "./indicator.vue?vue&type=style&index=0&id=0c3dd10a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3dd10a"],['__file',"src/pages/scada/components/indicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c3dd10a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c3dd10a', __exports__)) {
    console.log('reload')
    api.reload('0c3dd10a', __exports__)
  }
  
  module.hot.accept("./indicator.vue?vue&type=template&id=0c3dd10a&scoped=true", () => {
    console.log('re-render')
    api.rerender('0c3dd10a', render)
  })

}


export default __exports__